import { render, staticRenderFns } from "./OrganizationPeerGroupSettingsGuard.vue?vue&type=template&id=2e30c6e0&"
import script from "./OrganizationPeerGroupSettingsGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupSettingsGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports